import {
  ApplicationConfig,
  isDevMode,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling
} from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { provideHighcharts } from 'highcharts-angular';

import { routes } from './app.routes';

/**
 * The service worker is what lets a new deployment reach an already-open tab, so
 * it must stay off during local development - a registered worker would serve
 * stale chunks over the dev server's live rebuilds.
 */
function isLocalhost(): boolean {
  const host = globalThis.location?.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // Zoneless change detection: zone.js is no longer shipped or patched onto
    // the browser globals, and Angular only re-renders on signal writes and
    // template event bindings. Every component is OnPush + signal driven to
    // match.
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })
    ),
    // Highcharts is code split out of the initial bundle and fetched on demand
    // the first time a <highcharts-chart> renders.
    provideHighcharts(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode() && !isLocalhost(),
      // Register the service worker once the application is stable, or after
      // 30 seconds - whichever comes first.
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};
